"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const utils_1 = require("@obvio/utils");
const link_1 = __importDefault(require("next/link"));
const react_1 = require("react");
const appContext_1 = require("./appContext");
const resources_1 = require("./resources");
const env_1 = require("../env");
const lib_1 = require("../lib");
const theme_1 = require("../theme");
const StyledAnchor = theme_1.styled.a `
  color: inherit;
`;
const LinkContext = (0, react_1.createContext)(false);
function useParentAnchor() {
    return (0, react_1.useContext)(LinkContext);
}
exports.Link = (0, react_1.forwardRef)((_a, ref) => {
    var _b;
    var { children, onClick, className, kind, current, sameTab, href: hrefProp, shallow, scroll, replace, prefetch } = _a, props = __rest(_a, ["children", "onClick", "className", "kind", "current", "sameTab", "href", "shallow", "scroll", "replace", "prefetch"]);
    const { locale } = (0, lib_1.useTranslation)();
    const isClient = (0, lib_1.useIsClient)();
    const { asPath } = (0, lib_1.useRouter)();
    const { resourceLinks, globalStoreHook: useGlobalStore } = (0, appContext_1.useAppContext)();
    const actionRef = (0, react_1.useRef)(null);
    const onClickRef = (0, react_1.useRef)(onClick);
    onClickRef.current = onClick;
    const [, dispatch] = useGlobalStore();
    const isNestedAnchor = useParentAnchor();
    let hrefString = String(hrefProp || '#');
    if ((0, resources_1.isResourceLink)(hrefString)) {
        const { scope, id } = (0, lib_1.parseResourceLink)(hrefString);
        hrefString = (_b = resourceLinks === null || resourceLinks === void 0 ? void 0 : resourceLinks[hrefString]) !== null && _b !== void 0 ? _b : '#';
        actionRef.current = scope === 'action' ? id : null;
    }
    const [href, as] = (0, lib_1.routerUrl)(hrefString, locale);
    const handleClick = (0, react_1.useCallback)((ev) => {
        var _a;
        if (actionRef.current) {
            dispatch(actionRef.current);
        }
        (_a = onClickRef.current) === null || _a === void 0 ? void 0 : _a.call(onClickRef, ev);
    }, [dispatch]);
    if (isNestedAnchor) {
        return ((0, jsx_runtime_1.jsx)("span", Object.assign({ ref: ref, className: className }, props, { children: children })));
    }
    const active = current !== null && current !== void 0 ? current : asPath.split('?')[0] === (hrefString === null || hrefString === void 0 ? void 0 : hrefString.split('?')[0]);
    const externalLink = isExternal(href);
    const openInNewTab = externalLink && !sameTab;
    const anchorHref = as !== null && as !== void 0 ? as : href;
    const anchor = ((0, jsx_runtime_1.jsx)(StyledAnchor, Object.assign({ ref: ref, css: (0, theme_1.css)((theme) => kind && kind !== 'box' && theme.links.css, (theme) => (kind ? theme.links[kind] : theme.links.css)), className: className, onClick: handleClick }, (isClient && active ? { 'aria-current': 'true' } : {}), (anchorHref !== '#' && { href: anchorHref }), (externalLink && { rel: 'noopener noreferrer' }), (openInNewTab && { target: '_blank' }), props, { children: (0, jsx_runtime_1.jsx)(LinkContext.Provider, Object.assign({ value: true }, { children: children })) })));
    return as === undefined ? (anchor) : ((0, jsx_runtime_1.jsx)(link_1.default, Object.assign({ passHref: true, legacyBehavior: true }, (0, utils_1.exclude)({ href, as, shallow, scroll, replace, prefetch }, undefined), { children: anchor })));
});
function isExternal(href) {
    return (!lib_1.INTERNAL_HREF_REGEX.test(href) && new URL(href).origin !== (0, env_1.getHomeUrl)());
}
